import {useEffect} from "react";
import {Button, Card, Result} from "antd";
import {HomeOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";

const NotFound = () => {
  useEffect(() => {
    document.title = "USDSeller | 404 - Не найдено";
  }, []);

  return (
    <div className="not-found-page">
      <Card className="not-found-card">
        <Result
          status="404"
          title="Страница не найдена"
          subTitle="Запрашиваемая страница еще в разработке или не существует."
          extra={

            <Button className="button-bg-alone button-text-primary justify-self-center" type="primary" icon={<HomeOutlined/>}>
              <Link to="/">
                На главную
              </Link>
            </Button>
          }
        />
      </Card>
    </div>
  );
};

export default NotFound;